import {GenericServices} from "./generic.services";
import {
	IPropertyListingModel,
	IPropertyModel,
	IPropertyParameterModel,
	IPropertyRelationModel,
	IPropertyRoomModel,
	PropertyModel,
	BuildingImportUnitParamModel,
    IPropertyPictureModel,
    IPropertyVideoModel
} from "../models/property";

import {ApiResponse} from "../models/app-configuration";
import projectUri from "../common/uri/project-uri.constants";
import Uri from "../common/uri/property-uri.constants";
import {DataHelper} from "../utils/data-helper";
import {GenericBaseParameter} from "../models/base-parameter";
import {Listing} from "../models/listing-base-model";
import {
	Building ,
	BuildingTranslation ,
	IBuiding ,
} from "../models/project/project-building.model";
import {
	PICTURES_OF_ENVIRONMENT ,
	PROPERTY_TAB_ENVIRONMENTS
} from "../common/property.constant";
import { CloneProjectRequest, ICloneProjectResponse } from '../models/property/';
import { itemStateConstant } from "../common";

export class ProjectServices extends GenericServices {
	constructor() {
		super();
	}
	
	initProject() {
		return super.executeSelecting(undefined, projectUri.new)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					//const project: IPropertyModel = new PropertyModel({ ...response.data['Project'], GoogleX: BELGIUM_LOCATION.Latitude, GoogleY: BELGIUM_LOCATION.Longtitude })
					const project: IPropertyModel = new PropertyModel(response.data['Project'])
					delete project.Id;
					return Promise.resolve(project);
				}
				return Promise.reject(response.message);
			})
			.catch(error => Promise.reject(error));
	}
	
	insertProject(project: IPropertyModel) {
		delete project.PoiOfEnvironment;
		delete project.PicturesOfEnvironment;
		delete project.Prospection;
		return super.executeCreating(project, projectUri.default)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(response.data)
					: Promise.reject(response)
			})
			.catch(error => Promise.reject(error))
	}

	getQuickSearchProjects(ids: number[]) {
        if (ids.length <= 0)
            return Promise.reject('List of project ids must be more than 0');
        let url = Uri.getQuickSearchProjects.replace(':ids', ids.join(','))
        return super.executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex)
                return Promise.reject(ex)
            });
    }

	getProjectPreview(projectId: number, tabs?: string, excludeTabs?: string) {
		let path = projectUri.projectPreview.replace(':id', projectId.toString());
		const payload = {
			tabs: tabs ? tabs : "*"
		}

		if (excludeTabs) {
			payload["exclude-tabs"] = excludeTabs;
		}
		
		return super.executeSelectingNotEncode(payload,path)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(new PropertyModel(response.data));
				}
				return Promise.reject(response.message)
			}).catch(error => Promise.reject(error))
	}

	getProjectByTabView(project: IPropertyModel, tabName: string, propertyName: string) {
		if (propertyName === 'None') return Promise.resolve(project);
		if (project.Id > 0)
			if (Object.keys(project).indexOf(propertyName) === -1 ||  (project[propertyName].length == 0 && propertyName !== PROPERTY_TAB_ENVIRONMENTS) || (propertyName === PROPERTY_TAB_ENVIRONMENTS && project[PICTURES_OF_ENVIRONMENT].length === 0)) {
				return super.executeSelectBy({ id: project.ProjectId, tab: tabName, propertyid: project.Id }, projectUri.getProjectTabViewMode)
					.then((response: ApiResponse) => {
						return response.isSuccess
							? Promise.resolve(response.data)
							: Promise.reject(response.message);
					})
					.catch(ex => {
						console.log(ex)
						return Promise.reject(ex)
					});
			}
			else {
				return Promise.resolve({ [propertyName]: project[propertyName] })
			}
		else {
			if (Object.keys(project).indexOf(propertyName) === -1) {
				return Promise.resolve({ [propertyName]: [] })
			} else return Promise.resolve({ [propertyName]: project[propertyName] });
		}
	}
	
	getProjectById(propertyId: number, loadTabs:string[] = []) {
		let path = projectUri.detail;
		
		if(loadTabs.length>0)
		{
			path+="?load-tab="+loadTabs.join(",");
		}
		
		return super.executeSelectBy({ id: propertyId },path)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(new PropertyModel(response.data));
				}
				return Promise.reject(response.message)
			}).catch(error => Promise.reject(error))
	}
	
	updateProject(property: IPropertyModel, originObject: IPropertyModel) {
		delete property.IntermMandateReference;
        delete property.ProlongationTaskDate;
        property.CheckingConfictData = property.ModifiedDate;
        originObject.CheckingConfictData = '';
        const parsedOrigin = this.parseProperty(originObject).next().value;
        const parsedProject = this.parseProperty(property).next().value;
		return super.executeUpdating(originObject.ProjectId, parsedOrigin, parsedProject, projectUri.default)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(response.data)
					: Promise.reject(response)
			})
			.catch(error => Promise.reject(error))
	}
	
	getContentByTabNameForProject(project: IPropertyModel, tabName: string, propertyName: string) {
		if (propertyName === 'None') return Promise.resolve(project);
		if (project.Id > 0)
			if (Object.keys(project).indexOf(propertyName) === -1 ||  (project[propertyName].length == 0 && propertyName !== PROPERTY_TAB_ENVIRONMENTS) || (propertyName === PROPERTY_TAB_ENVIRONMENTS && project[PICTURES_OF_ENVIRONMENT].length === 0)) {
				return super.executeSelectBy({ id: project.ProjectId, tab: tabName, propertyid: project.Id }, projectUri.loadContentByTabName)
					.then((response: ApiResponse) => {
						return response.isSuccess
							? Promise.resolve(response.data)
							: Promise.reject(response.message);
					})
					.catch(ex => {
						console.log(ex)
						return Promise.reject(ex)
					});
			}
			else {
				return Promise.resolve({ [propertyName]: project[propertyName] })
			}
		else {
			if (Object.keys(project).indexOf(propertyName) === -1) {
				return Promise.resolve({ [propertyName]: [] })
			} else return Promise.resolve({ [propertyName]: project[propertyName] });
		}
	}
	
	getListOfProjectUnits(param: GenericBaseParameter<IPropertyParameterModel>) {
		return super.executeSelectingPost(param, projectUri.searchUnits)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(new Listing<IPropertyListingModel>('listOfProperties', response.data))
					: Promise.reject(response.message)
			})
			.catch(error => Promise.reject(error))
	}

	getListOfFinanceLinkedUnits(projectId :number,param?: GenericBaseParameter<IPropertyParameterModel>) {
		let url =  projectUri.fianceSearchLinkedUnits;
		
		url = url.replace(":projectId",projectId.toString());

		return super.executeSelectingPost(param, url)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(new Listing<IPropertyListingModel>('listOfProperties', response.data))
					: Promise.reject(response.message)
			})
			.catch(error => Promise.reject(error))
	}
	
	getProjectStatusConfigs() {
		return super.executeSelecting(undefined, projectUri.statusConfigLookup)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve((response.data && response.data.Records) || [])
					: Promise.reject(response.message)
			})
			.catch(error => Promise.reject(error))
	}

	copyToUnits(projectId: number, req: any) {
		return super.executeSelectingPost(req, projectUri.copyToUnits.replace(':projectId',projectId.toString()))
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(response.data)
					: Promise.reject(response.message)
			})
			.catch(error => Promise.reject(error))
	}
	
	protected *projectBuildingInit(payload) {
		let building: IBuiding = {
			Id: payload.Id,
			ProjectId: payload.ProjectId,
            OrderByBuilding: payload.OrderByBuilding,
            PhaseNumber: payload.PhaseNumber,
			Description: new BuildingTranslation(payload.Description),
			Units: [],
			ItemState: 1
		};
		yield new Building(building);
	}
	
	private *parseProperty(property: IPropertyModel) {
		const prod = DataHelper.deepClone<IPropertyModel>(property);
		if (prod.Rooms)
            prod.Rooms = property.Rooms.map((room: IPropertyRoomModel) => this.getRoom(room).next().value) as any;
		if (prod.Relations)
            prod.Relations = property.Relations.map((relation: IPropertyRelationModel) => this.getRelation(relation).next().value) as any;
        if (prod.Pictures)
            prod.Pictures = this.transformPicture(prod.Pictures);
        if (prod.ProjectEvolutionPictures)
            prod.ProjectEvolutionPictures = this.transformPicture(prod.ProjectEvolutionPictures);
        if (prod.ProjectEnvironmentPictures)
            prod.ProjectEnvironmentPictures = this.transformPicture(prod.ProjectEnvironmentPictures);
        if (prod.Videos) {
            prod.Videos = property.Videos.map(
                (video: IPropertyVideoModel) => this.getVideo(video).next().value
            ) as any;
        }
		yield prod;
    }
    
    private transformPicture(picture: IPropertyPictureModel[]) {
        picture.forEach(pic => {
            delete pic.updateKey;
        });
        return picture;
    }
	
	private *getRoom(room: IPropertyRoomModel) {
		const r = <IPropertyRoomModel>{
			StateId: room.StateId,
			ItemState: room.ItemState,
			DescriptionId: room.DescriptionId,
			FloorCoveringId: room.FloorCoveringId,
			FloorId: room.FloorId,
			Width: room.Width,
			Length: room.Length,
			Area: room.Area,
			OrderNr: room.OrderNr,
			CommentsNL: room.CommentsNL,
			CommentsFR: room.CommentsFR,
			CommentsEN: room.CommentsEN
		}
		if (room.Id) {
			r.Id = room.Id;
			r.PropertyId = room.PropertyId;
		}
		yield r;
	}
	
	private *getRelation(relation: IPropertyRelationModel) {
		const rel = <IPropertyRelationModel>{
      PersonId: relation.PersonId,
      RelationTypeId: relation.RelationTypeId,
      Comment: relation.Comment,
      IsMain: relation.IsMain,
      IsSendReport: relation.IsSendReport,
      PersonIndex: relation.PersonIndex,
      C21ContactListingId: relation.C21ContactListingId,
      Confirm: relation.Confirm,
      Time: relation.Time,
      IsSendAppointmentConfirmations: relation.IsSendAppointmentConfirmations,
      PersonName: relation.PersonName,
      PersonFirstName: relation.PersonFirstName,
      PersonCompanyName: relation.PersonCompanyName,
      PersonReference: relation.PersonReference,
      PersonEmail: relation.PersonEmail,
      PersonEmail2: relation.PersonEmail2,
      PersonEmail3: relation.PersonEmail3,
      PersonComment: relation.PersonComment,
      PersonCityName: relation.PersonCityName,
      RelationTypeNameNL: relation.RelationTypeNameNL,
      RelationTypeNameFR: relation.RelationTypeNameFR,
      RelationTypeNameEN: relation.RelationTypeNameEN,
      ItemState: relation.ItemState,
      PersonEmails: relation.PersonEmails,
      PersonPhones: relation.PersonPhones,
      RelationTypeNameDE: relation.RelationTypeNameDE,
      CompanyName: relation.CompanyName,
      PersonCountryId: relation.PersonCountryId,
      PersonLanguageId: relation.PersonLanguageId,
      PersonPostCode: relation.PersonPostCode,
      PersonStreet: relation.PersonStreet,
      PersonStreet2: relation.PersonStreet2,
      PhoneDesc3: relation.PhoneDesc3,
      PhoneDesc2: relation.PhoneDesc2,
      PhoneDesc1: relation.PhoneDesc1,
      PhoneDesc4: relation.PhoneDesc4,
      PhoneDesc5: relation.PhoneDesc5,
      PhoneDesc6: relation.PhoneDesc6,
      PhoneDesc7: relation.PhoneDesc7,
      PhoneDesc8: relation.PhoneDesc8,
      PhoneDesc9: relation.PhoneDesc9,
      PhoneDesc10: relation.PhoneDesc10,
      PersonHouseNumber: relation.PersonHouseNumber,
      PhoneNumber1: relation.PhoneNumber1,
      PhoneNumber2: relation.PhoneNumber2,
      PhoneNumber3: relation.PhoneNumber3,
      PhoneNumber4: relation.PhoneNumber4,
      PhoneNumber5: relation.PhoneNumber5,
      PhoneNumber6: relation.PhoneNumber6,
      PhoneNumber7: relation.PhoneNumber7,
      PhoneNumber8: relation.PhoneNumber8,
      PhoneNumber9: relation.PhoneNumber9,
      PhoneNumber10: relation.PhoneNumber10,
      PersonBoxNumber: relation.PersonBoxNumber,
      PersonVAT: relation.PersonVAT,
      PersonIDCardNumber: relation.PersonIDCardNumber,
      PersonBirthday: relation.PersonBirthday,
      PersonBirthplace: relation.PersonBirthplace,
      CompanyId: relation.CompanyId,
      StartCommercialisation: relation.StartCommercialisation,
		}
		if (relation.Id) {
			rel.Id = relation.Id;
			rel.PropertyId = relation.PropertyId;
		}
		yield rel;
	}

    private *getVideo(video: IPropertyVideoModel) {
        const result: IPropertyVideoModel = {
            Id: video?.Id,
            ObjectId: video?.ObjectId,
            VideoId: video?.VideoId,
            Type: video?.Type ?? 1,
            Order: video.Order ?? 0,
            ItemState: video.ItemState ?? itemStateConstant.Unchanged
        };
        yield result;
    }

	getImportUnitTemplate(): Promise<any> {
        const url = Uri.getImportUnitTemplate;
        return this.getBlobFile(url).then((response: ApiResponse) => {
            return response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message);
        }).catch(err => Promise.reject(err))
    }

    exportBuldingUnits(projectId: number, buildingId: number): Promise<any> {
		let url = Uri.exportBuidingUnits;
		url = url + `?projectId=${projectId}&buildingId=${buildingId}`
        return this.getBlobFile(url).then((response: ApiResponse) => response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message))
        .catch(err => Promise.reject(err))
    }

    importUnitToBuilding(formData: FormData): Promise<any> {
		const url = Uri.importBuildingUnits;
        return this.executePost(
            formData,
            url,
            {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }
        ).then((response: ApiResponse) => response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message))
		.catch(err => Promise.reject(err))
	}
    importUnit(record: BuildingImportUnitParamModel): Promise<any> {
		const url = Uri.importBuildingUnit;
        return this.executePost(
            record,
            url
        ).then((response: ApiResponse) => response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message))
		.catch(err => Promise.reject(err))
	}
	
	cloneProject(request: CloneProjectRequest, projectId: number): Promise<ICloneProjectResponse> {
        let cloneUrl = Uri.cloneProject.replace(':id', projectId.toString());

        return super.executeCreating(request, cloneUrl)
            .then((response: ApiResponse) => response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response))
            .catch(ex => Promise.reject(ex))
	}
	
	parseExcelFile(formData: FormData): Promise<any> {
		const url = Uri.parseExcelFile;
        return this.executePost(
            formData,
            url,
            {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }
        ).then((response: ApiResponse) => response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message))
		.catch(err => Promise.reject(err))
	}

	loadUnitsByBuildingId(payload: {projectId: number, buildingId: number, params: GenericBaseParameter<any>}) {

		let url =  projectUri.loadUnitsByBuildingId;
		url = url
			.replace(":projectId", payload.projectId.toString())
			.replace(":buildingId", payload.buildingId.toString());

		return super.executeSelectingPost(payload.params, url)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve( response.data)
					: Promise.reject(response.message)
			})
			.catch(error => Promise.reject(error))
	}
}
